import { render, staticRenderFns } from "./GlassDialog.vue?vue&type=template&id=04d8c468&"
import script from "./GlassDialog.vue?vue&type=script&lang=js&"
export * from "./GlassDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports